import * as React from 'react';
declare const I18n;
import { Collapse } from 'react-collapse';
import DOMPurify from 'dompurify/dist/purify.min';
import { Resource } from '../../../../types';
import BreadCrumb from '../../../BreadCrumb';
import Section from '../../../Section';
import { submitResource, setResourceInProgress } from '../../../../api/resource';
import { resourceLimits } from 'worker_threads';


type Props = {
  initialData: {
    resource: Resource,
    resourceCategoryId: number,
    resourceCategoryTitle: string,
    resourceFile: string,
    length_estimate?: string,
    userType?: string
  },
}

const ShowLesson: React.FunctionComponent<Props> = ({ initialData: { resource, resourceCategoryId, resourceCategoryTitle, userType, resourceFile } }: Props): JSX.Element => {
  const [sectionsArray, setSectionsArray] = React.useState([]);
  const [completed, setCompleted] = React.useState(resource.completed || false);
  const isLearner = !!(userType && userType === 'Learner');

  const DOMPurifyConfig = {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['target', 'allow', 'allowfullscreen', 'frameborder', 'scrolling', 'src', 'width', 'height']
  };

  const handleCompleteResource = async () => {
    try {
      await submitResource(resource.id, {
        learner_id: (window as any).CURRENT_LEARNER_ID,
      });
      setCompleted(!completed)
    } catch (error) {
    }
  };

  const handleSetResourceInProgress = async () => {
    try {
      await setResourceInProgress(resource.id, {
        learner_id: (window as any).CURRENT_LEARNER_ID,
      });
    } catch (error) {
    }
  };

  React.useEffect(() => {
    const sectionArray = resource.sections.map((section) => {
      return {
        isOpen: false
      };
    });

    setSectionsArray(sectionArray);
  }, []);

  let locations = []

  if (userType && userType.toLowerCase() === "admin") {
    locations = [
      { title: I18n.t('models.resource_category.messaging.explore_resources'), url: '/admin/explore_categories' },
      { title: I18n.t('models.resource_category.attributes.categories'), url: '/admin/explore_categories/all' },
      { title: resourceCategoryTitle, url: `/admin/explore_categories/${resourceCategoryId}/resources` },
      { title: resource.title, url: '' },
    ]
  } else {
    locations = [
      { title: I18n.t('models.resource_category.messaging.explore_resources'), url: '/explore_categories' },
      { title: resource.title, url: '' },
    ]
  }

  return (
    <div className="lessons_show">
      <BreadCrumb
        locations={locations}
      />
      <div className="page-subinformation">
        {(resource as any).resource_category_name && (
          <a href={`/explore_categories/${resourceCategoryId}/resources`}
            className="category-list">
            {(resource as any).resource_category_name}
          </a>
        )}
        {(resource.length_estimate !== 'null' && resource.length_estimate !== null && resource.length_estimate != '') &&
          <div className="flex-row">
            <div className="duration">
              <i className="far fa-clock icon"></i>
              &nbsp;
              {resource.length_estimate}
            </div>
          </div>
        }
      </div>
      <h1>{resource.title}</h1>
      <div className="lessons_show__body">
        <Section
          title={I18n.t('views.common.overview')}
        />

        <div
          className="section__body app-text"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(resource.body, DOMPurifyConfig) }}
        />

        {
          resource.sections.map((section, index) => {
            return (
              <div
                className="lessons_show__section"
                key={section.id}
              >
                <Section
                  title={section.title}
                  withInput={section.questions.length > 0}
                  withBorder
                  index={index + 1}
                  iconId={section.id}
                  onArrowPress={() => {
                    const newArray = sectionsArray;

                    newArray[index].isOpen = !newArray[index].isOpen;

                    setSectionsArray([...newArray]);
                  }}
                />

                <Collapse isOpened={sectionsArray[index] && sectionsArray[index].isOpen}>
                  <div
                    className="section__body app-text"
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(section.content, DOMPurifyConfig) }}
                  />
                </Collapse>
              </div>
            )
          }
          )
        }
        <div className="button-area" style={{ display: 'flex', gap: '1.5em' }}>
          {resource.file_name && (
            <a
              href={'/uploads/' + resourceFile}
              target="_blank"
              download={resource.file_name}
              className={`btn btn-primary`}
              style={{
                alignSelf: 'flex-start',
              }}
            >
              {I18n.t('models.resource.messaging.download_resource')}
            </a>
          )
          }
          {isLearner && (
            <button
              type="button"
              className={`btn pull-right btn-primary`}
              onClick={handleCompleteResource}
              style={{
                alignSelf: 'flex-start',
              }}
            >
              {completed ? (
                <>
                  <i className="fa-solid fa-square-check" style={{ marginRight: '0.5rem', color: "#044305" }}></i>
                  {I18n.t("models.resource.messaging.completed")}
                </>
              ) : (
                <>
                  <i className="fa-regular fa-square" style={{ marginRight: '0.5rem', color: "#044305" }}></i> {I18n.t("models.resource.messaging.mark_as_completed")}
                </>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ShowLesson;
